"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyRoutePlanReschedule = exports.DailyRoutePlanUpdate = exports.DailyRoutePlanCreateFromTemplate = exports.SubscriptionDailyRoutePlanTransport = exports.DailyRoutePlanCreate = exports.DailyRoutePlanQuery = exports.DailyRoutePlanTransport = exports.DailyRoutePlan = exports.DailyRoutePlanStatusType = exports.DailyRoutePlanStatusTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const RoutePlanTemplate_1 = require("../route-planning/RoutePlanTemplate");
const ActualRouteBreadcrumb_1 = require("./ActualRouteBreadcrumb");
const RoutePlanSchedule_1 = require("./RoutePlanSchedule");
const RoutePlanStop_1 = require("./RoutePlanStop");
//unassign, no driver is attached
//assigned, driver is attached
//in progress, driver is en route
//complete, driver has completed
//issue, overall route has an issue -- don't know the scenario where this would be used yet
exports.DailyRoutePlanStatusTypes = ['UNASSIGNED', 'ASSIGNED', 'IN_PROGRESS', 'COMPLETE', 'ISSUE'];
exports.DailyRoutePlanStatusType = typebox_1.Type.Union(exports.DailyRoutePlanStatusTypes.map((val) => typebox_1.Type.Literal(val)));
exports.DailyRoutePlan = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    stops: typebox_1.Type.Array(RoutePlanStop_1.RoutePlanStop),
    fromPlanTemplate: typebox_1.Type.Optional(RoutePlanTemplate_1.RoutePlanTemplate),
    breadcrumbs: typebox_1.Type.Optional(typebox_1.Type.Array(ActualRouteBreadcrumb_1.ActualRouteBreadcrumb)),
    schedule: RoutePlanSchedule_1.RoutePlanSchedule,
    tainted: typebox_1.Type.Boolean({
        description: 'The daily route has changed from the template since being generated.',
    }),
    metadata: common_1.MetaData,
    status: exports.DailyRoutePlanStatusType,
});
exports.DailyRoutePlanTransport = exports.DailyRoutePlan;
exports.DailyRoutePlanQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        fromPlanTemplateID: typebox_1.Type.String({ format: 'uuid' }),
        tainted: typebox_1.Type.Boolean(),
        status: exports.DailyRoutePlanStatusType,
        scheduleDate: typebox_1.Type.String({ format: 'date' }),
        fromDate: typebox_1.Type.String({ format: 'date' }),
        toDate: typebox_1.Type.String({ format: 'date' }),
        isRescheduled: typebox_1.Type.Boolean(),
    }),
]));
exports.DailyRoutePlanCreate = typebox_1.Type.Object({
    name: typebox_1.Type.String(),
    schedule: RoutePlanSchedule_1.RoutePlanScheduleCreate,
    attachStopIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
    status: typebox_1.Type.Optional(exports.DailyRoutePlanStatusType),
});
exports.SubscriptionDailyRoutePlanTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(exports.DailyRoutePlanStatusType),
});
exports.DailyRoutePlanCreateFromTemplate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DailyRoutePlan, [
        'id',
        'haulerID',
        'stops',
        'fromPlanTemplate',
        'breadcrumbs',
        'schedule',
        'metadata',
        'tainted',
        'status',
    ]),
    typebox_1.Type.Object({
        date: typebox_1.Type.String({ format: 'date' }),
        fromPlanTemplateID: typebox_1.Type.String({ format: 'uuid' }),
        status: typebox_1.Type.Optional(exports.DailyRoutePlanStatusType),
        allowAnyDate: typebox_1.Type.Optional(typebox_1.Type.Boolean({
            description: 'If true, date checks will not be performed on the route, or any of the stops. overrideRealizedStopIDs should also be provided.',
        })),
        allowDuplicate: typebox_1.Type.Optional(typebox_1.Type.Boolean({
            description: 'If true, a route plan can be created with the same date and template, even if one already exists.',
        })),
    }),
]);
exports.DailyRoutePlanUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DailyRoutePlan, [
        'id',
        'haulerID',
        'stops',
        'fromPlanTemplate',
        'breadcrumbs',
        'schedule',
        'metadata',
        'tainted',
        'status',
    ]),
    typebox_1.Type.Object({
        attachStopIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({
            format: 'uuid',
            description: 'This must contain all stops otherwise the ordinal cant be guaranteed',
        }))),
        schedule: RoutePlanSchedule_1.RoutePlanScheduleUpdate,
        status: typebox_1.Type.Optional(exports.DailyRoutePlanStatusType),
    }),
]));
exports.DailyRoutePlanReschedule = typebox_1.Type.Object({
    dailyRouteIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    newDate: typebox_1.Type.String({ format: 'date' }),
});
//# sourceMappingURL=DailyRoutePlan.js.map